// extracted by mini-css-extract-plugin
export default {"greyLightColor":"#F6F6F6","skeleton":"skeleton_skeleton__fSKwP","container":"Skeleton_container__EdWNT skeleton_skeleton__fSKwP"};